import { ChangeDetectorRef, } from '@angular/core';
import { ControlValueAccessor, } from '@angular/forms';
import padStart from 'lodash-es/padStart';
import * as moment from 'moment';
var UiDateTimePickerComponent = /** @class */ (function () {
    function UiDateTimePickerComponent(_cd) {
        this._cd = _cd;
        this.datePlaceholder = 'Date';
        this.timePlaceholder = 'Time';
        this.timePickerDirection = 'down';
        this.values = [];
        this._value = null;
        this.onChange = function () { };
        this.onTouch = function () { };
        for (var i = 0; i < 24; i += 1) {
            for (var j = 0; j < 60; j += 15) {
                this.values.push({
                    id: i + ":" + j,
                    text: padStart(i.toString(), 2, '0') + ":" + padStart(j.toString(), 2, '0'),
                });
            }
        }
        this._time = [this.values[0]];
    }
    Object.defineProperty(UiDateTimePickerComponent.prototype, "date", {
        get: function () {
            return this._value;
        },
        set: function (date) {
            if (date == null) {
                this._value = null;
                this.onChange(this.value);
                return;
            }
            this._value =
                date.startOf('day')
                    .date(date.date())
                    .month(date.month())
                    .year(date.year());
            this.time = this._time;
            this.onChange(this.value);
            this._cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiDateTimePickerComponent.prototype, "time", {
        get: function () {
            return this._time;
        },
        set: function (time) {
            var _a = time[0].text.split(':', 2), hours = _a[0], minutes = _a[1];
            if (this._value) {
                this._value = this._value
                    .hours(Number(hours))
                    .minutes(Number(minutes));
            }
            this._time = time;
            this.onChange(this.value);
            this._cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiDateTimePickerComponent.prototype, "value", {
        get: function () {
            return this._value ? this._value.toDate() : this._value;
        },
        enumerable: true,
        configurable: true
    });
    UiDateTimePickerComponent.prototype.writeValue = function (date) {
        if (!date) {
            return;
        }
        var value = moment(date);
        // discard seconds & milliseconds
        value.startOf('minute');
        var hours = value.hours();
        var minutes = Math.floor(value.minutes() / 15) * 15;
        value.minutes(minutes);
        this._time = [this.values.find(function (v) { return v.id === hours + ":" + minutes; })];
        this._value = value;
        this._cd.markForCheck();
    };
    UiDateTimePickerComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    UiDateTimePickerComponent.prototype.registerOnTouched = function (fn) {
        this.onTouch = fn;
    };
    return UiDateTimePickerComponent;
}());
export { UiDateTimePickerComponent };
